import {
  getDefaultErrorMessage
} from "./chunk-DGEY3FWG.mjs";

// src/context.ts
import {
  createContext as reactCreateContext,
  useContext as useReactContext
} from "react";
function createContext(options) {
  const {
    name,
    strict = true,
    defaultValue,
    hookName = "useContext",
    providerName = "Provider",
    errorMessage: rootErrorMessage
  } = options;
  const Context = reactCreateContext(defaultValue);
  Context.displayName = name;
  function useContext(errorMessage) {
    var _a;
    const context = useReactContext(Context);
    if (!context && strict) {
      const error = new Error(
        (_a = errorMessage != null ? errorMessage : rootErrorMessage) != null ? _a : getDefaultErrorMessage(hookName, providerName)
      );
      error.name = "ContextError";
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext, Context];
}

export {
  createContext
};
